class HorizontalScroll extends HTMLElement {
    constructor() {
        super();
        const element = this.querySelector("[data-horizontal-scrollable]");
        this.showScrollButtons =
            this.getAttribute("show-scroll-buttons") === "true" ||
            !this.hasAttribute("show-scroll-buttons");
        this.customBackgroundColor = this.getAttribute(
            "custom-background-color",
        );
        this.scrollEffectLeft = false;
        this.scrollEffectRight = false;
        this.scrollLeftButton = false;
        this.scrollRightButton = false;
        this.scrollableElement = element;
        this.isDown = false;
        this.velocity = 0;
        this.currentScrollLeft = null;
        this.startX = null;
        this.lastX = this.startX;
        this.settings =
            this.getAttribute("data-settings") &&
            JSON.parse(this.getAttribute("data-settings"));
    }
    connectedCallback() {
        if (!this.scrollableElement) {
            this.scrollableElement = this.querySelector(
                "[data-horizontal-scrollable]",
            );
        }

        if (this.scrollableElement) {
            this.attachListeners();
            this.checkIsOverFlow();
            this.renderScrollButtons();
            this.handleCheckResize();
        }
        document.addEventListener("on:color-item:change", (event) =>
            this.onColorItemChange(event),
        );
    }

    disconnectedCallback() {
        this.removeEventListener("attachListeners", this.attachListeners());
        this.removeEventListener("checkIsOverFlow", this.checkIsOverFlow());
        this.removeEventListener(
            "handleScrollButtons",
            this.handleScrollButtons(),
        );
        this.removeEventListener(
            "renderScrollButtons",
            this.renderScrollButtons(),
        );
        this.removeEventListener("handleCheckResize", this.handleCheckResize());
        this.removeEventListener(
            "handleSmoothDeceleration",
            this.handleSmoothDeceleration,
        );
    }

    checkIsOverFlow() {
        if (
            this.scrollableElement.scrollWidth <=
            this.scrollableElement.clientWidth
        ) {
            if (this.scrollEffectRight) {
                this.scrollEffectRight.style.opacity = "0";
                this.scrollEffectRight.style.visibility = "hidden";
            }

            if (this.scrollRightButton) {
                this.scrollRightButton.style.opacity = "0";
                this.scrollRightButton.style.visibility = "hidden";
            }
        } else {
            if (this.scrollableElement.scrollLeft > 0) {
                this.scrollLeftButton.style.opacity = "1";
                this.scrollLeftButton.style.visibility = "visible";
            }
            const totalScroll =
                this.scrollableElement.scrollLeft +
                this.scrollableElement.clientWidth;
            if (this.scrollRightButton) {
                this.scrollRightButton.style.opacity =
                    totalScroll < this.scrollableElement.scrollWidth
                        ? "1"
                        : "0";
                this.scrollRightButton.style.visibility =
                    totalScroll < this.scrollableElement.scrollWidth
                        ? "visible"
                        : "hidden";
            }
        }
    }

    attachListeners() {
        this.scrollableElement.addEventListener("mousedown", (e) => {
            this.isDown = true;
            e.preventDefault();
            this.startX = e.pageX - this.scrollableElement.offsetLeft;
            this.currentScrollLeft = this.scrollableElement.scrollLeft;
            this.velocity = 0;
            this.lastX = this.startX;
        });

        this.scrollableElement.addEventListener("mouseup", (e) => {
            this.isDown = false;
            e.preventDefault();
            this.scrollableElement.classList.remove("dragging");

            // Start smooth deceleration
            this.handleSmoothDeceleration();
        });

        this.scrollableElement.addEventListener("mousemove", (e) => {
            if (!this.isDown) return;
            e.preventDefault();
            //this.scrollableElement.scrollLeft -= e.movementX;
            this.scrollableElement.classList.add("dragging");

            const x = e.pageX - this.scrollableElement.offsetLeft;
            const walk = x - this.startX;
            this.scrollableElement.scrollLeft = this.currentScrollLeft - walk;

            this.velocity = this.lastX - x;
            this.lastX = x;
        });

        this.scrollableElement.addEventListener("mouseleave", (e) => {
            this.isDown = false;
            this.scrollableElement.classList.remove("dragging");
            e.preventDefault();

            // Start smooth deceleration
            this.handleSmoothDeceleration();
        });

        this.scrollableElement.addEventListener("scroll", () => {
            const currentScroll = Math.ceil(this.scrollableElement.scrollLeft);
            if (currentScroll <= 0) {
                if (this.scrollEffectLeft) {
                    this.scrollEffectLeft.style.opacity = "0";
                    this.scrollEffectLeft.style.visibility = "hidden";
                }

                if (this.scrollLeftButton) {
                    this.scrollLeftButton.style.opacity = "0";
                    this.scrollLeftButton.style.visibility = "hidden";
                }
            } else {
                if (this.scrollEffectLeft) {
                    this.scrollEffectLeft.style.opacity = "1";
                    this.scrollEffectLeft.style.visibility = "visible";
                }
                if (this.scrollLeftButton) {
                    this.scrollLeftButton.style.opacity = "1";
                    this.scrollLeftButton.style.visibility = "visible";
                }
            }

            if (
                currentScroll >=
                this.scrollableElement.scrollWidth -
                    this.scrollableElement.offsetWidth
            ) {
                if (this.scrollEffectRight) {
                    this.scrollEffectRight.style.opacity = "0";
                    this.scrollEffectRight.style.visibility = "hidden";
                }

                if (this.scrollRightButton) {
                    this.scrollRightButton.style.opacity = "0";
                    this.scrollRightButton.style.visibility = "hidden";
                }
            } else {
                if (this.scrollEffectRight) {
                    this.scrollEffectRight.style.opacity = "1";
                    this.scrollEffectRight.style.visibility = "visible";
                }

                if (this.scrollRightButton) {
                    this.scrollRightButton.style.opacity = "1";
                    this.scrollRightButton.style.visibility = "visible";
                }
            }
        });
        // TODO will not be used until the difference between touchpad and mouse wheel is clear
        /*
        this.scrollableElement.addEventListener("wheel", (e) => {
            e.preventDefault();    
            if(e.deltaX === -0) {
                this.scrollableElement.scrollLeft += e.deltaY;
            } else if(e.deltaY === -0) {
                this.scrollableElement.scrollLeft += e.deltaX;
            }
        }, 
        { passive: false }); */
    }

    handleScrollButtons(leftButton, rightButton) {
        if (leftButton) {
            leftButton.addEventListener("click", (e) => {
                e.preventDefault();
                if (
                    this.scrollableElement.scrollLeft -
                        this.scrollableElement.clientWidth <=
                    0
                ) {
                    this.scrollableElement.style.scrollBehavior = "smooth";
                    this.scrollableElement.scrollLeft = 0;
                    this.scrollableElement.style.scrollBehavior = "auto";
                } else {
                    this.scrollableElement.style.scrollBehavior = "smooth";
                    this.scrollableElement.scrollLeft -=
                        this.scrollableElement.clientWidth;
                    this.scrollableElement.style.scrollBehavior = "auto";
                }
            });
        }

        if (rightButton) {
            rightButton.addEventListener("click", (e) => {
                e.preventDefault();
                if (
                    this.scrollableElement.scrollLeft +
                        this.scrollableElement.clientWidth >=
                    this.scrollableElement.scrollWidth
                ) {
                    this.scrollableElement.style.scrollBehavior = "smooth";
                    this.scrollableElement.scrollLeft =
                        this.scrollableElement.scrollWidth;
                    this.scrollableElement.style.scrollBehavior = "auto";
                } else {
                    this.scrollableElement.style.scrollBehavior = "smooth";
                    this.scrollableElement.scrollLeft +=
                        this.scrollableElement.clientWidth;
                    this.scrollableElement.style.scrollBehavior = "auto";
                }
            });
        }
    }

    renderScrollButtons() {
        if (this.showScrollButtons) {
            const leftEffect = document.createElement("div");
            const rightEffect = document.createElement("div");
            const leftButton = document.createElement("div");
            const rightButton = document.createElement("div");
            leftEffect.classList.add("scroll-before");
            rightEffect.classList.add("scroll-after");
            leftButton.classList.add("scroll-left");
            rightButton.classList.add("scroll-right");
            leftButton.innerHTML =
                '<svg class="Icon Icon--select-arrow-left" role="presentation" viewBox="0 0 11 18"><path d="M9.5 1.5L1.5 9l8 7.5" stroke-width="2" stroke="currentColor" fill="none" fill-rule="evenodd" stroke-linecap="square"></path></svg>';
            rightButton.innerHTML =
                '<svg class="Icon Icon--select-arrow-right" role="presentation" viewBox="0 0 11 18"><path d="M1.5 1.5l8 7.5-8 7.5" stroke-width="2" stroke="currentColor" fill="none" fill-rule="evenodd" stroke-linecap="square"></path></svg>';
            this.scrollLeftButton = leftButton;
            this.scrollRightButton = rightButton;
            //this.scrollEffectLeft = leftEffect;
            //this.scrollEffectRight = rightEffect;
            if (this.settings?.buttonWidth) {
                leftButton.style.padding = `${this.settings.buttonWidth}px`;
                rightButton.style.padding = `${this.settings.buttonWidth}px`;
                leftButton.querySelector("svg").style.width =
                    `${this.settings.buttonWidth}px`;
                leftButton.querySelector("svg").style.height =
                    `${this.settings.buttonWidth}px`;
                rightButton.querySelector("svg").style.width =
                    `${this.settings.buttonWidth}px`;
                rightButton.querySelector("svg").style.height =
                    `${this.settings.buttonWidth}px`;
            }
            this.append(leftButton, rightButton);
            this.handleScrollButtons(leftButton, rightButton);
            this.checkIsOverFlow();
        }
    }

    handleCheckResize() {
        const resizeObserver = new ResizeObserver((entries) => {
            for (const entry of entries) {
                this.checkIsOverFlow();
            }
        });
        resizeObserver.observe(this);
    }

    handleSmoothDeceleration() {
        // Smooth deceleration function
        if (Math.abs(this.velocity) < 0.1) {
            this.velocity = 0; // Stop if speed is too low
            return;
        }

        // Continue scrolling while reducing speed
        this.scrollableElement.scrollLeft += this.velocity;
        this.velocity *= 0.85; // Deceleration factor

        requestAnimationFrame(() => this.handleSmoothDeceleration());
    }

    onColorItemChange(event) {
        if (event.detail.productHandle) {
            this.renderScrollButtons();
        }
    }
}

customElements.define("horizontal-scroll", HorizontalScroll);
